export const fontFamily = {
    manrope: "Manrope"
}
